import { ProposalEvidence } from './types';

export const proposalEvidenceKey = (item: ProposalEvidence): string =>
  JSON.stringify([item.sourceUrl ?? null, item.quote ?? null]);

export const uniqueProposalEvidence = (
  evidence: ProposalEvidence[],
): ProposalEvidence[] => {
  const seen = new Set<string>();
  return evidence.filter((item) => {
    const key = proposalEvidenceKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
